// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Backdrop */
.lp-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.lp-modal-content-backdrop {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  /* Modal Container */
  .modal-container {
    background: white;
    border-radius: 20px;
    max-width: 1200px;
    width: 100%;
    height: auto;
    max-height: 90vh;
    display: flex;
    overflow: hidden;
    position: relative;
    animation: slideUp 0.3s ease;
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  /* Close Button */
  .modal-close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }
  
  .modal-close-btn:hover {
    background: #ff4d4d;
    color: white;
    transform: rotate(90deg);
  }
  
  /* Image Section */
  .modal-image-section {
    flex: 1.5 1;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  
  .modal-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  /* Details Section */
  .modal-details-section {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 32px;
    gap: 24px;
  }
  
  /* User Header */
  .modal-user-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .modal-user-avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    overflow: hidden;
    background: #007BFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .avatar-placeholder {
    color: white;
  }
  
  .modal-user-info {
    flex: 1 1;
  }
  
  .modal-username {
    font-size: 20px;
    font-weight: 700;
    color: #2c2c2c;
    margin: 0 0 8px 0;
  }
  
  .modal-post-time {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #888;
    margin: 0;
  }
  
  /* Description */
  .modal-description {
    font-size: 15px;
    line-height: 1.6;
    color: #4a4a4a;
  }
  
  .modal-description p {
    margin: 0;
  }
  
  /* Location */
  .modal-location {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 12px;
    font-size: 14px;
    color: #2c2c2c;
    font-weight: 500;
  }
  
  .modal-location svg {
    color: #007BFF;
  }
  
  /* Stats */
  .modal-stats {
    display: flex;
    gap: 24px;
    padding: 16px 0;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .stat-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    color: #4a4a4a;
    font-weight: 500;
  }
  
  .stat-item svg {
    color: #007BFF;
  }
  
  /* Action Buttons */
  .modal-actions {
    display: flex;
    gap: 12px;
  }
  
  .action-btn {
    flex: 1 1;
    padding: 14px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .action-btn:hover {
    border-color: #007BFF;
    color: #007BFF;
    background: rgba(0, 123, 255, 0.05);
  }
  
  .like-btn.liked {
    border-color: #ff4d4d;
    color: #ff4d4d;
    background: rgba(255, 77, 77, 0.05);
  }
  
  /* Tags */
  .modal-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .tag {
    padding: 6px 14px;
    background: #f0f0f0;
    border-radius: 20px;
    font-size: 13px;
    color: #007BFF;
    font-weight: 500;
  }
  
  /* Responsive */
  @media (max-width: 968px) {
    .modal-container {
      flex-direction: column;
      max-height: 95vh;
    }
  
    .modal-image-section {
      flex: 1 1;
      max-height: 50vh;
    }
  
    .modal-details-section {
      flex: 1 1;
      max-height: 45vh;
    }
  }
  
  @media (max-width: 640px) {
    .modal-backdrop {
      padding: 0;
    }
  
    .modal-container {
      border-radius: 0;
      max-height: 100vh;
    }
  
    .modal-details-section {
      padding: 24px 20px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/LocationPage/Styles/ImageModal.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;EAEE;IACE,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;EACnB;;EAEA,oBAAoB;EACpB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA,iBAAiB;EACjB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;EAC1B;;EAEA,kBAAkB;EAClB;IACE,WAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,SAAS;EACX;;EAEA,gBAAgB;EAChB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA,aAAa;EACb;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA,UAAU;EACV;IACE,aAAa;IACb,SAAS;IACT,eAAe;IACf,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,mCAAmC;EACrC;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,mCAAmC;EACrC;;EAEA,SAAS;EACT;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,eAAe;EACf;IACE;MACE,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,SAAO;MACP,gBAAgB;IAClB;;IAEA;MACE,SAAO;MACP,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":["/* Modal Backdrop */\n.lp-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  z-index: 1000;\n  padding: 20px;\n  animation: fadeIn 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.lp-modal-content-backdrop {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n}\n  \n  @keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n  \n  /* Modal Container */\n  .modal-container {\n    background: white;\n    border-radius: 20px;\n    max-width: 1200px;\n    width: 100%;\n    height: auto;\n    max-height: 90vh;\n    display: flex;\n    overflow: hidden;\n    position: relative;\n    animation: slideUp 0.3s ease;\n  }\n  \n  @keyframes slideUp {\n    from {\n      transform: translateY(50px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n  \n  /* Close Button */\n  .modal-close-btn {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.9);\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 10;\n    transition: all 0.3s ease;\n  }\n  \n  .modal-close-btn:hover {\n    background: #ff4d4d;\n    color: white;\n    transform: rotate(90deg);\n  }\n  \n  /* Image Section */\n  .modal-image-section {\n    flex: 1.5;\n    background: #000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n  }\n  \n  .modal-image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n  \n  /* Details Section */\n  .modal-details-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    padding: 32px;\n    gap: 24px;\n  }\n  \n  /* User Header */\n  .modal-user-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  \n  .modal-user-avatar {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #007BFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .modal-user-avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .avatar-placeholder {\n    color: white;\n  }\n  \n  .modal-user-info {\n    flex: 1;\n  }\n  \n  .modal-username {\n    font-size: 20px;\n    font-weight: 700;\n    color: #2c2c2c;\n    margin: 0 0 8px 0;\n  }\n  \n  .modal-post-time {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    color: #888;\n    margin: 0;\n  }\n  \n  /* Description */\n  .modal-description {\n    font-size: 15px;\n    line-height: 1.6;\n    color: #4a4a4a;\n  }\n  \n  .modal-description p {\n    margin: 0;\n  }\n  \n  /* Location */\n  .modal-location {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 16px;\n    background: #f8f9fa;\n    border-radius: 12px;\n    font-size: 14px;\n    color: #2c2c2c;\n    font-weight: 500;\n  }\n  \n  .modal-location svg {\n    color: #007BFF;\n  }\n  \n  /* Stats */\n  .modal-stats {\n    display: flex;\n    gap: 24px;\n    padding: 16px 0;\n    border-top: 1px solid #e0e0e0;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  \n  .stat-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 15px;\n    color: #4a4a4a;\n    font-weight: 500;\n  }\n  \n  .stat-item svg {\n    color: #007BFF;\n  }\n  \n  /* Action Buttons */\n  .modal-actions {\n    display: flex;\n    gap: 12px;\n  }\n  \n  .action-btn {\n    flex: 1;\n    padding: 14px 20px;\n    border: 2px solid #e0e0e0;\n    border-radius: 12px;\n    background: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .action-btn:hover {\n    border-color: #007BFF;\n    color: #007BFF;\n    background: rgba(0, 123, 255, 0.05);\n  }\n  \n  .like-btn.liked {\n    border-color: #ff4d4d;\n    color: #ff4d4d;\n    background: rgba(255, 77, 77, 0.05);\n  }\n  \n  /* Tags */\n  .modal-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  \n  .tag {\n    padding: 6px 14px;\n    background: #f0f0f0;\n    border-radius: 20px;\n    font-size: 13px;\n    color: #007BFF;\n    font-weight: 500;\n  }\n  \n  /* Responsive */\n  @media (max-width: 968px) {\n    .modal-container {\n      flex-direction: column;\n      max-height: 95vh;\n    }\n  \n    .modal-image-section {\n      flex: 1;\n      max-height: 50vh;\n    }\n  \n    .modal-details-section {\n      flex: 1;\n      max-height: 45vh;\n    }\n  }\n  \n  @media (max-width: 640px) {\n    .modal-backdrop {\n      padding: 0;\n    }\n  \n    .modal-container {\n      border-radius: 0;\n      max-height: 100vh;\n    }\n  \n    .modal-details-section {\n      padding: 24px 20px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
